export default __webpack_public_path__ + "static/linea3-preview-2-mb-c289de04975d5f1f1419066ed41441c5.png";